export default "__VITE_ASSET__BrH6lCpt__"